module.exports = __webpack_public_path__ + "img/hero-still_en.c0a8d91.jpg";